// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Text } from '@mantine/core';
import { FC } from 'react';
import { BookitupNotification } from '../../../../Types/LogT';

const TaskCompleted: FC<{ notification: BookitupNotification }> = ({ notification }) => {
  const { entityLabel } = notification;
  return (
    <Text>
      Aufgabe{' '}
      <Text span weight="bolder">
        {entityLabel}
      </Text>{' '}
      wurde abgeschlossen.
    </Text>
  );
};

export default TaskCompleted;
